import { motion } from "motion/react"
import { RegisterState } from "../actions/register"
import { ErrorMessage, Field, Label } from "@ui/fieldset"
import { Input } from "@ui/input"
import { Select } from "@ui/select"

interface Props {
    countries:
        | {
              value: string
              label: string
          }[]
        | undefined
    formState: RegisterState
}

export function FullNameField({ formState }: { formState: RegisterState }) {
    return (
        <Field className="col-span-full">
            <Label>Full name</Label>
            <Input
                name="full_name"
                type="text"
                autoComplete="name"
                invalid={Array.isArray(formState.errors?.fullName) && formState.errors.fullName.length > 0}
                required
                minLength={2}
            />
            {formState.errors?.fullName && (
                <ErrorMessage>
                    {formState.errors.fullName.map((error) => (
                        <p key={error}>{error}</p>
                    ))}
                </ErrorMessage>
            )}
        </Field>
    )
}

export function EmailField({
    formState,
}: {
    formState: {
        errors?:
            | {
                  email?: string[] | undefined
              }
            | undefined
    }
}) {
    return (
        <Field className="col-span-full">
            <Label>Email address</Label>
            <Input
                name="email"
                type="email"
                autoComplete="email"
                invalid={Array.isArray(formState.errors?.email) && formState.errors.email.length > 0}
                required
            />
            {formState.errors?.email && (
                <ErrorMessage>
                    {formState.errors.email.map((error) => (
                        <p key={error}>{error}</p>
                    ))}
                </ErrorMessage>
            )}
        </Field>
    )
}

export function CountryField({ countries, formState }: Props) {
    return (
        <Field className="col-span-full">
            <Label>Country</Label>
            <Select
                name="country"
                invalid={Array.isArray(formState.errors?.country) && formState.errors.country.length > 0}
                required
            >
                <optgroup>
                    <option value="">Select a country</option>
                    <option>United Kingdom</option>
                    <option>United States</option>
                </optgroup>

                <optgroup>
                    {countries?.map((country) => (
                        <option key={country.value} value={country.value}>
                            {country.label}
                        </option>
                    ))}
                </optgroup>
            </Select>
            {formState.errors?.country && (
                <ErrorMessage>
                    {formState.errors.country.map((error) => (
                        <p key={error}>{error}</p>
                    ))}
                </ErrorMessage>
            )}
        </Field>
    )
}

export function IndividualSubForm({ countries, formState }: Props) {
    return (
        <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.3 }}
        >
            <div className="grid grid-cols-1 gap-6">
                <FullNameField formState={formState} />
                <EmailField formState={formState} />
                <CountryField countries={countries} formState={formState} />
            </div>
        </motion.div>
    )
}
